import { AlertModalLayout, Button } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

import { StyledModal } from './outdated-version.styled';

/**
 * This modal needs to be refactored. See: https://linear.app/neo-tax/issue/NEO-3826/app-wide-alert-modal
 */
export const OutdatedVersionModal = (): ReactElement | null => (
  <StyledModal isOpen={true} setIsOpen={(): void => {}}>
    <AlertModalLayout
      title="Application Updated"
      copy="We just updated the app. Please refresh the page to use the latest version. If you continue to see this message after a refresh, then a better version of the app is still being deployed. Please wait a few minutes and try to refresh again."
      trailingContent={
        <Button size="base" variant="primary" rounded="regular" onClick={(): void => location.reload()}>
          Refresh
        </Button>
      }
    />
  </StyledModal>
);
